import { useState } from "react";
import Layout from "../../../Containers/Layout";
import { Table, Input, Typography, Button, Tooltip } from "antd";
import { useQuery } from "react-query";
import { getLaboratories } from "../../../Requests/laboratory-data-requests";
import { useParams } from "react-router-dom";
import { getStudyProgram } from "../../../Requests/study-program-request";
import { LaboratoryCategoryEnum } from "../../../Api";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadExcel } from "../../../utils/downloadUtils";
import { NOTIFICATION_TYPES, openNotification } from "../../Notifications/NotificationsUtils";
const { Title } = Typography;
const { Search } = Input;

const LaboratoriesTable = () => {
    const [searchID, setSearchID] = useState('');
    const [searchNumber, setSearchNumber] = useState('');
    const [searchName, setSearchName] = useState('');
    const { programId, schoolYear } = useParams<{ programId: string, schoolYear: string }>();

    const { data, isLoading, error } = useQuery(
        ['getLaboratories', programId, schoolYear],
        async () => {
            const response = await getLaboratories(programId, Number(schoolYear));
            return response;
        }
    );

    const { data: program } = useQuery(
        ["getProgram", programId], 
        () => getStudyProgram(programId)
      );

    const laboratoriesData = data ? data : [];

    const filteredData = laboratoriesData.filter((item) => {
        const matchesNumber = searchNumber ? item.number?.toLowerCase().includes(searchNumber.toLowerCase()) : true;
        const matchesName = searchName ? item.name?.toLowerCase().includes(searchName.toLowerCase()) : true;
        return matchesNumber && matchesName;
    });

    const columns = [
        {
            title: <Search placeholder="Număr" allowClear onSearch={setSearchNumber} />,
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: <Search placeholder="Nume" allowClear onSearch={setSearchName} />,
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: "Categorie",
            dataIndex: 'category',
            key: 'category',
            render: (category: LaboratoryCategoryEnum) => (
                category === LaboratoryCategoryEnum.Technological ? "Tehnologic" : "Informatic"
            ),
        },
        {
            title: "Suprafață",
            dataIndex: 'area',
            key: 'area',
        },
        {
            title: "Capacitate",
            dataIndex: 'capacity',
            key: 'capacity',
        },
        {
            title: "Discipline",
            dataIndex: 'disciplines',
            key: 'disciplines',
            render: (disciplines: string[]) => (
                disciplines.length > 0
                    ? (
                        <div>
                            {disciplines.map((discipline, index) => (
                                <Typography.Text key={index} style={{ display: 'block' }}>
                                    {discipline}
                                </Typography.Text>
                            ))}
                        </div>
                    )
                    : "N/A"
            ),
        },
    ];

    const reportColumns = [
        {
            title: 'Număr',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: 'Nume',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: "Categorie",
            dataIndex: 'category',
            key: 'category',
        },
        {
            title: "Suprafață",
            dataIndex: 'area',
            key: 'area',
        },
        {
            title: "Capacitate",
            dataIndex: 'capacity',
            key: 'capacity',
        },
        {
            title: "Discipline",
            dataIndex: 'disciplines',
            key: 'disciplines',
        }              
    ];

    const openErrorNotification = (error: string, message: string) => {
        openNotification(
            error,
            message,
            NOTIFICATION_TYPES.ERROR
        );
    }

    const downloadReport = async () => {
        let fileName = 'Laboratoare - ' + (program?.name ?? '') + '.xlsx';
        return downloadExcel(fileName, reportColumns.map(e => { return { header: e.title, key: e.key?.toString() ?? '' } }),
            laboratoriesData.map(lab => {
                return {
                    ...lab,
                    disciplines: lab.disciplines?.join(", "),
                    category: lab.category === LaboratoryCategoryEnum.Technological ? "Tehnologic" : "Informatic"
                }
            }))
        .then(
        () => {
            openNotification("Succes!", "Raportul a fost descărcat cu succes!", NOTIFICATION_TYPES.SUCCESS);
        },
        () => {
            openNotification("Eroare!", "Raportul nu a putut fi descărcat cu succes!", NOTIFICATION_TYPES.ERROR);
        });
    }

    return (
        <Layout>
            <div style={{ padding: '20px' }}>
                {isLoading && <div>Loading...</div>}
                {error && <div>Error loading data</div>}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                    <Title level={3} style={{ margin: 0 }}>
                        Laboratoare - {program?.name}
                    </Title>
                    <Tooltip title="Descărcare raport">
                        <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={downloadReport}
                        >
                        Descărcare raport
                        </Button>
                    </Tooltip>
                </div>
                <Table
                    dataSource={filteredData || []}
                    columns={columns}
                    rowKey="id"
                    locale={{
                        emptyText: "No data available",
                    }}
                    pagination={false}
                />
            </div>
        </Layout>
    );
};

export default LaboratoriesTable;